export const formatNumber = (value: number) => {
  const truncated = Math.floor(value || 0);
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(
    truncated,
  );
};

export const formatPercentageShort = (value: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(value || 0);

export const shortNumber = (value: number) =>
  new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 1,
  }).format(value || 0);

export const formatMilliseconds = (value: number) =>
  new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
  }).format(value || 0);
